module.exports = __webpack_public_path__ + "img/17_55.f17ba026.png";